import React, { useState, useEffect } from 'react';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import { SelectChangeEvent } from '@mui/material';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { getNodeData } from '../../../store';
import { TextComponent, SelectComponent } from '../../uiComponents';
import { OptionProps } from '../../../view-models';
import jsonComponentsConfig from '../../../constants/jsonComponents';
import useComponentUIHook from './useComponentUIHook';
import SessionManagement, { sessionFieldsAreValid } from './sessionManagement';

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  setUnsavedChanges: any;
}

const GenerateUsernamePasswordValidationUI = ({
  componentData,
  closeGritComponent,
  setUnsavedChanges,
}: componentProps) => {
  const configData = jsonComponentsConfig.usernamePasswordValidation.data;
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows, allClaims } = useComponentUIHook(componentData);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows();
    setDisableSubmit(_res || (!sessionFieldsAreValid(modifiedData)));
    setUnsavedChanges(_res);
  }, [modifiedData]);
  const nodeData = useSelector(getNodeData);
  const classes = jsonEditorStyles();

  return (
    <div className={classes.flexCol}>
      <div className={classes.flexRow}>
        {(nodeData[modifiedData['subflowParent']]?.componentType !== 'signIn') && (
          <>
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<any>) => {
                setModifiedData({ ...modifiedData, ['usernameType']: e.target.value });
              }}
              data={{
                value: modifiedData.usernameType,
                label: configData.usernameType.displayName,
                options: configData.usernameType.values.reduce(
                  (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                  [],
                ),
                style: { margin: 1, width: 300 },
                required: true,
              }}
            />
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<any>) => {
                setModifiedData({ ...modifiedData, ['username']: e.target.value });
              }}
              data={{
                value: modifiedData.username,
                label: configData.username.displayName,
                options:
                  configData.username.values === 'allClaims'
                    ? Object.keys(allClaims).reduce(
                        (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                        [],
                      )
                    : [],
                style: { margin: 1, width: 300 },
                required: true,
              }}
            />
          </>
        )}
        {(nodeData[modifiedData['subflowParent']]?.componentType === 'signIn') && (
          <>
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {}}
              data={{
                value: modifiedData.usernameType,
                label: configData.usernameType.displayName,
                disabled: true,
              }}
            />
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {}}
              data={{
                value: modifiedData.username,
                label: configData.username.displayName,
                disabled: true,
              }}
            />
          </>
        )}
        <TextComponent
          changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {}}
          data={{
            value: modifiedData?.password,
            label: 'Password Attribute',
            disabled: true,
          }}
        />
      </div>
      <FormControl required sx={{ m: 1, minWidth: 600 }}>
        <div>
          If the validation is successful, the object Id of the user would be returned. Pick the claim to map it.
        </div>
        <Grid container direction="row" justifyContent="space-between">
          <Grid item xs={5}>
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<string>) => {
                setModifiedData({
                  ...modifiedData,
                  claim: e.target.value,
                });
              }}
              data={{
                value: modifiedData?.claim || '',
                label: 'Claims',
                options: Object.keys(allClaims)
                  .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
                  .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1)),
                required: true,
              }}
            />
          </Grid>
          <Grid item xs></Grid>
        </Grid>
        <div>If the validation is failed, an error message would be returned as shown below, </div>
        <TextComponent
          changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            setModifiedData({ ...modifiedData, ['errorMsg']: e.target.value });
          }}
          data={{
            value: modifiedData?.errorMsg,
            label: 'Error Message',
          }}
        />
        {configData.sessionManagement && (
          <SessionManagement
            modifiedData={modifiedData}
            changeHandler={(data: any) => setModifiedData(data)}
            sessionTypes={configData.sessionTypes}
          />
        )}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            closeGritComponent(modifiedData);
          }}
          disabled={disableSubmit}
        >
          Save
        </Button>
      </FormControl>
    </div>
  );
};

// export default withAITracking(reactPlugin, GenerateUsernamePasswordValidationUI);
export default GenerateUsernamePasswordValidationUI;
